import React, { Fragment, useState } from 'react'
import { SearchAsync } from '../../components/elements/SearchAsync';
import { Card, Col, Container, FormGroup, Row, Table, Label, Input, FormFeedback } from 'reactstrap';
import { useQuatation } from '../../hooks/quoter/useQuatation'
import './QuoteStyle.css';
import 'animate.css';
import { TableQuoter } from './TableQuoter';
import { ModalViewExamsQuoter } from './ModalViewExamsQuoter';
import { ModalRepeatProfile } from '../../components/workOrders/ModalRepeatProfile';
import DeniReactTreeView from "deni-react-treeview"
import Select, { components } from 'react-select';
import { DialogPreviewPdf } from './DialogPreviewPdf';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';




export const IndexQuoter = () => {


	const {
		// ? DIALOG QUOTER
		modalTitle, modalRepeatProfile, modalViewExamsP, toggleModalViewExams, toggleRepeatProfile,

		// ? VALUE
		observations, listQuoterTest, name, paternal_surname, maternal_surname, email,
		handleInputChange, totalW, subTotalW, totalTaxesW,
		examProfileState, viewExamsProfile, viewButtons, validationsRepeat,

		// ? QUOTER METHODS
		handleSelectExamChange, deleteExamProfile, handleCheckUrgent, handleCheckSpecimen,
		handleViewExamsProfile, saveCreate, sentPdf, phone, validationsSG, handleChangePercentage, lab,

		// ? CONFIGURATION QUOTER
		itemsTree, treeviewRef,

		// ? CONFIGURATION TYPE CLIENT 
		handleChangeTypeClient, chekTypeClient, id_agreement, listAgreement, handleSelectValues, loadingQuoter, number_format,

		// ? CONFIGURATION SEARCH QUOTER
		dataQuoter, handleFilterValues, date_ini, date_end, searchQuotes, downdloadQuoter, handleMouseEnter, handleMouseLeave, isHovered,
		showPreview, pdfPreviewUrl, handleOpenPreview, setPdfPreviewUrl, setShowPreview,
		loadingDownloadId, loadingPreviewId, handleSearch, exportExcel, loadingQuoterFilter,

		// ? CONFIGURATION PRELOADED
		listPreloaded, id_preloaded_discount, validatePreloadedDiscount, activeIndex, setActiveIndex, loading, progress, totalDiscountW,

		// ? CONFIGURATION HEADER
		viewDetailQuoter, handleViewQuoter, handleClosedQuoter,
		viewIndication, handleViewIndications, handleClosedIndications, loadingCreate, viewQuoter, loadingSend,
		removePreloadedDiscount

	} = useQuatation();
	console.log("🚀 ~ IndexQuoter ~ activeIndex:", activeIndex)



	const divStyle = {
		backgroundColor: isHovered ? "#1e90ff" : "#46afe5",
		borderColor: "#46afe5",
		color: "#fff",
		textAlign: "center",
		cursor: "pointer",
		padding: "8px 16px",
	};

	const headerStyle = {
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "12px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle = {
		fontSize: "12px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",

	};

	const header = (
		<div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
			<Button
				color="success"
				onClick={exportExcel}
				size="sm"
				title="Exportar a Excel"
				className="d-flex align-items-center"
				style={{ borderRadius: "8px", fontWeight: "bold", backgroundColor: '#4CAF50', color: 'white' }}

			>
				<i className="pi pi-file-excel me-2" />
			</Button>
			<Input
				type="search"
				placeholder="Buscar....."
				onChange={handleSearch}
				className="form-control"
				style={{
					maxWidth: "400px",
					borderRadius: "8px",
					padding: "6px 10px",
					fontSize: "14px",
				}}
			/>
		</div>
	);

	const CustomButton = () => {
		return (
			<Button
				label={loadingCreate ?
					<>
						<i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} />
						Generando cotización...
					</>
					:
					"Generar Cotización"}
				severity="warning"
				rounded
				style={{
					fontSize: '14px',
					padding: '0.5em 1em',
					borderRadius: '50px',
					width: '100%',
					display: 'block',
				}}
				disabled={listQuoterTest.length === 0 ? true : loadingCreate ? true : false}
				onClick={() => saveCreate()}
			/>
		);
	};

	const CustomIndication = () => {
		return (
			<Col sm="12">
				<h5>Indicaciones de estudios</h5>
				<Col sm="12" className='pb-1' style={{ textAlign: "right" }} >
					<Tag className='pointer' severity={viewIndication ? "danger" : "primary"} onClick={() => viewIndication ? (handleClosedIndications()) : (handleViewIndications())} value={viewIndication ? "Cerrar indicaciones" : "Indicaciones"} ></Tag>
				</Col>
				<div style={{ border: "1px solid #efefef", padding: "10px", backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}>
					{itemsTree && itemsTree.length > 0 ? (
						<DeniReactTreeView
							key={JSON.stringify(itemsTree)}
							ref={treeviewRef}
							style={{ marginRight: '10px', marginBottom: '10px', width: "97%", textAlign: "center" }}
							showCheckbox={false}
							showIcon={false}
							items={itemsTree}
							onRenderItem={onRenderItem}
						/>
					) : (
						<label className='txt-danger f-w-500 f-14' ><i className="fa fa-warning "></i> Sin indicaciones previas de estudios</label>
					)}
				</div>
			</Col>
		)
	}

	// ? DETAIL STUDY
	const CustomStudy = () => {
		return (
			<Col sm="5">
				{
					!viewQuoter &&
					<>
						{
							viewIndication
								?
								<>
									<CustomIndication />
								</>
								:
								<>
									{
										viewDetailQuoter ?
											<>
												<h5>Resúmen de cotización</h5>
												<Col sm="12" className='pb-2' style={{ textAlign: "right" }} >
													<Tag className='pointer' severity={viewIndication ? "danger" : "primary"} onClick={() => viewIndication ? (handleClosedIndications()) : (handleViewIndications())} value={viewIndication ? "Cerrar indicaciones" : "Indicaciones"} ></Tag>
													<Tag className='pointer' severity={viewDetailQuoter ? "danger" : "warning"} onClick={() => viewDetailQuoter ? (handleClosedQuoter()) : (handleViewQuoter())} value={viewDetailQuoter ? "Finalizar resúmen" : "Resúmen"} ></Tag>
												</Col>
												<Col sm="12" className="shadow-sm p-l-0 p-r-0" style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }} >
													<Col sm="12" className="p-l-0 p-r-0">
														<div className="d-flex justify-content-between align-items-center">
															<div className="d-flex align-items-center">
																<i className="fa fa-angle-left f-20"></i>
																<label style={{ fontSize: "15px" }} >Estudios a realizar</label>
															</div>
															<div className="d-flex align-items-center">
																<label style={{ fontSize: "15px" }}>{listQuoterTest.length + " Estudios"}</label>
																<i className="icofont icofont-laboratory"></i>
															</div>
														</div>
														<div className="line"></div>
													</Col>
													<Col className={listQuoterTest.length === 0 ? "" : "d-none"} sm="12" style={{ border: "1px solid #efefef", padding: "10px", backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }} >
														<label className='txt-danger f-w-500 f-14' ><i className="fa fa-warning "></i> Sin estudios cotizados</label>
													</Col>
													<Col sm="12" className='p-l-0 p-r-0 pt-4'>
														{listQuoterTest.length > 0 && (
															<table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
																<thead>
																	<tr style={{ backgroundColor: "#f4f4f4" }}>
																		<th style={{ textAlign: "left", padding: "8px", border: "1px solid #ddd" }}>Nombre</th>
																		<th style={{ textAlign: "left", padding: "8px", border: "1px solid #ddd" }}>Descuento</th>
																		<th style={{ textAlign: "right", padding: "8px", border: "1px solid #ddd" }}>Precio</th>
																	</tr>
																</thead>
																<tbody>
																	{listQuoterTest.map((x, index) => (
																		<tr key={x.id_exam}>
																			<td style={{ padding: "8px", border: "1px solid #ddd" }}>
																				<b style={{ fontSize: "14px" }}>{x.name}</b>
																			</td>
																			<td style={{ padding: "8px", border: "1px solid #ddd" }}>
																				{x.id_preloaded_discount !== null && x.id_preloaded_discount !== undefined && x.id_preloaded_discount !== 0 ? (
																					<Tag severity="danger" value={x.percentage + "%"} style={{ fontSize: "12px" }}></Tag>
																				) : (
																					<span style={{ fontSize: "12px", color: "#111111ff" }}>N/A</span>
																				)}
																			</td>
																			<td style={{ padding: "8px", textAlign: "right", border: "1px solid #ddd" }}>
																				<b style={{ fontSize: "14px" }} className={x.is_urgent ? "text-danger" : ""}>
																					{x.config_iva
																						? x.id_agreement === null || x.id_agreement === 0
																							? `$ ${number_format(x.price.toFixed(2))}`
																							: `$ ${number_format(x.price_Agremment.toFixed(2))}`
																						: x.id_agreement !== null && x.id_agreement !== 0
																							? `$ ${number_format((x.price_Agremment * 1.16).toFixed(2))}`
																							: `$ ${number_format((x.price * 1.16).toFixed(2))}`}
																				</b>
																			</td>
																		</tr>
																	))}
																</tbody>
															</table>
														)}
													</Col>


												</Col>
											</>
											:
											<>
												<h5>Buscar estudios solicitados</h5>
												<Col sm="12" className='pb-1' style={{ textAlign: "right" }} >
													<Tag className='pointer' severity={viewDetailQuoter ? "danger" : "primary"} onClick={() => viewDetailQuoter ? (handleClosedIndications()) : (handleViewIndications())} value={viewDetailQuoter ? "Cerrar indicaciones" : "Indicaciones"} ></Tag>
													<Tag className='pointer' severity={viewDetailQuoter ? "danger" : "warning"} onClick={() => viewDetailQuoter ? (handleClosedQuoter()) : (handleViewQuoter())} value={viewDetailQuoter ? "Finalizar resúmen" : "Resúmen"} ></Tag>
												</Col>
												<Col sm="12" className='p-l-0 p-r-0 shadow-sm canvas-color ' style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px', fontSize: '12px' }}  >
													<FormGroup>
														<SearchAsync
															className="col-md-12"
															method={handleSelectExamChange}
															loincState={examProfileState}
															url="Profiles/SearchProfileExam"
															maxLenght={3}
															selectSize="col-md-12"
															isWorkOrder={true}
															mDisabled={chekTypeClient === 3 ? (id_agreement === null ? true : false) : false}
														/>
													</FormGroup>
													{
														listQuoterTest.length > 0 && <TableQuoter
															key={"table"}
															items={listQuoterTest}
															{...{
																handleCheckUrgent, deleteExamProfile,
																handleCheckSpecimen, deleteExamProfile, viewButtons, handleViewExamsProfile, handleChangePercentage, lab, number_format
															}}
														/>
													}
												</Col>
											</>
									}
								</>
						}
					</>
				}
				{
					viewQuoter && <CustomButtonDownload />
				}
			</Col>
		)
	}

	// ? DOWNLOAD
	const CustomButtonDownload = () => {
		return (
			<Col sm="12" className='p-l-0 p-r-0s' >
				<h5>Acciones</h5>
				<div
					style={{
						border: "1px solid #efefef",
						padding: "10px",
						backgroundColor: 'white',
						border: '1px solid #e0e0e0',
						borderRadius: '10px',
						fontSize: '12px',
					}}
					className='line-mic'
				>
					<Col sm="12">
						<div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
							<Button
								label={loadingSend ? "Enviando" : "Enviar"}
								icon={loadingSend ? "pi pi-spin pi-spinner" : "pi pi-envelope"}
								className="p-button p-button-rounded"
								style={loadingSend ? { backgroundColor: '#b39053ff', color: 'white', borderColor: '#f59e0b' } : { backgroundColor: '#f59e0b', color: 'white', borderColor: '#f59e0b' }}
								onClick={() => sentPdf()}
								disabled={loadingSend ? true : false}
							/>
							<Button
								label={loadingDownloadId === null ? "Descargar" : "Descargando"}
								icon={loadingDownloadId === null ? "pi pi-download" : "pi pi-spin pi-spinner"}
								className="p-button p-button-rounded"
								style={loadingDownloadId !== null ? { backgroundColor: '#82a483ff', color: 'white' } : { backgroundColor: '#4CAF50', color: 'white' }}
								onClick={() => downdloadQuoter()}
								disabled={loadingDownloadId !== null ? true : false}
							/>
						</div>
					</Col>
				</div>
			</Col>
		)
	}

	const onRenderItem = (item) => {
		const icon = item.isLeaf ? <i className='icofont icofont-prescription' ></i> : <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/typeService.svg")} style={{ width: "21px", height: "21px" }} />;
		const color = item.state === 1 ? "#000000" : item.state === 2 ? "#3c413ca6" : item.state === 3 ? "#1f9ad9" : item.state === 4 ? "#1f9ad9a3" : "#343a40"

		return (
			<div style={{ color, display: 'flex', alignItems: 'center' }}>
				<span style={{ marginRight: '5px' }}>{icon}</span>
				<span title={item.text}>{item.text}</span>
			</div>
		);
	};

	// ? CLEAR INPUT
	const CustomClearIndicator = (props) => {
		return (
			<components.ClearIndicator {...props}>
				<Button
					size="sm"
					onClick={props.clearValue}
					className="custom-clear-button"
				>
					<i className="pi pi-tag" style={{ marginRight: '5px' }}></i>
					Quitar
				</Button>
			</components.ClearIndicator>
		);
	};

	const {
		nameV, paternal_surnameV, maternal_surnameV
	} = validationsSG;


	console.log("🚀 ~ useQuatation ~ chekTypeClient:", chekTypeClient)

	let typeMenu = localStorage.getItem('menu') === "True";

	return (
		<Fragment>
			<div className={`${typeMenu ? "container-global-zoom" : "p-l-0 p-r-0 container-global-zoom"}`}>
				<Row>

					<Col sm="12">
						<Row>
							<Col sm="12" md={chekTypeClient === 0 ? "12" : "12"}>
								{
									!loadingQuoter && <Card>
										{
											// * MENU
										}
										<TabView
											activeIndex={activeIndex}
											onTabChange={(e) => {
												setActiveIndex(e.index);
												handleChangeTypeClient(e.index);
											}}
											className="full-width-tabview"
										>
											{
												//* SEARCH QUOTER
											}
											<TabPanel header={<><i className="pi pi-credit-card" style={{ marginRight: '8px' }}></i>Buscar Cotización</>}>
												<Col sm="12">
													<FormGroup>
														<Row className="g-3 align-items-center justify-content-start text-left">
															{/* Título Filtros */}
															<Col xs="auto" md="auto" className="mb-2">
																<h5 className="f-16 f-w-700 text-info mb-0">Filtros de búsqueda</h5>
															</Col>
															{/* Fecha inicio */}
															<Col xs="12" md="2" className="d-flex flex-column align-items-start mb-2 pl-0">
																<Label className="f-w-600 f-12 badge badge-light-primary mb-1">Fecha de inicio</Label>
																<Input
																	type="date"
																	style={{ fontSize: "14px", maxWidth: "100%" }}
																	value={date_ini}
																	className="form-control form-control-sm input-air-primary b-r-9 text-left"
																	name="start_date"
																	onChange={handleFilterValues}
																/>
															</Col>
															{/* Fecha final */}
															<Col xs="12" md="2" className="d-flex flex-column align-items-start mb-2 pl-0">
																<Label className="f-w-600 f-12 badge badge-light-primary mb-1">Fecha final</Label>
																<Input
																	type="date"
																	style={{ fontSize: "14px", maxWidth: "100%" }}
																	value={date_end}
																	className="form-control form-control-sm input-air-primary b-r-9 text-left"
																	name="end_date"
																	onChange={handleFilterValues}
																/>
															</Col>
															{/* Botón buscar */}
															<Col xs="12" md="2" className="d-flex flex-column align-items-start mt-3 pl-0">
																<div
																	onClick={() => searchQuotes()}
																	className="pointer w-100 text-left py-1"
																	style={{ ...divStyle, maxWidth: "120px" }}
																	onMouseEnter={handleMouseEnter}
																	onMouseLeave={handleMouseLeave}
																>
																	Buscar
																</div>
															</Col>
														</Row>
													</FormGroup>
												</Col>
												{
													// * TABLE QUOTER
												}
												<div className="full-width-content">
													<div className="table-responsive">
														<DataTable
															value={dataQuoter}
															paginator
															rows={10}
															className="data-table p-datatable-striped p-datatable-sm"
															emptyMessage={
																<div className="text-center">
																	<img src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
																	<br />
																	<p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>Sin cotizaciones.</p>
																</div>
															}
															loading={loadingQuoterFilter}
															rowsPerPageOptions={[10, 50, 100]}
															responsiveLayout="scroll"
															header={header}
														>
															<Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
															<Column field="code" header="Código" headerStyle={headerStyle} style={cellStyle} />
															<Column field="created_at" header="Fecha de creación" sortable headerStyle={headerStyle} style={cellStyle} />
															<Column field="client_type_text" header="Particular/Empresa" sortable body={(rowData) => rowData.client_type} headerStyle={headerStyle} style={cellStyle} />
															<Column field="company_name" header="Nombre" headerStyle={headerStyle} style={cellStyle} body={(rowData) => rowData.company_name ? rowData.company_name : rowData.client} />
															<Column field="status" header="Estatus" headerStyle={headerStyle} style={cellStyle} />
															<Column field="used_at" header="Fecha de uso" headerStyle={headerStyle} style={cellStyle} />
															<Column
																header="Acciones"
																headerStyle={headerStyle}
																style={{ ...cellStyle, textAlign: "center" }}
																body={(rowData) => (
																	<div className="d-flex justify-content-center gap-2">
																		<button
																			onClick={() => downdloadQuoter(rowData.id_quoter)}
																			title="Descargar"
																			disabled={loadingDownloadId === rowData.id_quoter}
																			style={{
																				width: "30px",
																				height: "30px",
																				fontSize: "0.65rem",
																				borderRadius: "8px",
																				padding: "0",
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center"
																			}}
																			className="btn btn-danger mr-1"
																		>
																			{loadingDownloadId === rowData.id_quoter ? (
																				<i className="fa fa-spinner fa-spin"></i>
																			) : (
																				<i className="fa fa-file-pdf-o"></i>
																			)}
																		</button>
																		<button
																			onClick={() => handleOpenPreview(rowData.id_quoter)}
																			title="Previsualizar Cotización"
																			disabled={loadingPreviewId === rowData.id_quoter}
																			style={{
																				width: "30px",
																				height: "30px",
																				fontSize: "0.65rem",
																				borderRadius: "8px",
																				padding: "0",
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center"
																			}}
																			className="btn btn-primary"
																		>
																			{loadingPreviewId === rowData.id_quoter ? (
																				<i className="fa fa-spinner fa-spin"></i>
																			) : (
																				<i className="icofont icofont-ui-search"></i>
																			)}
																		</button>
																	</div>
																)}
															/>
														</DataTable>
													</div>
												</div>
											</TabPanel>
											{
												// * PATIENT
											}
											<TabPanel header={<><i className="pi pi pi-user" style={{ marginRight: '8px' }}></i>Paciente particular</>}>
												<div className="full-width-content">
													<Col sm="12">
														<Row>
															<Col sm="4">
																<h5>Cliente</h5>
																<Row className='pt-2' >
																	<Col sm="4" className='pb-2' >
																		<b className="d-block mb-2" style={{ fontSize: "14px" }} >Nombre<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			disabled={viewQuoter ? true : false}
																			type="text"
																			name="name"
																			value={name}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(nameV ? 'border-danger' : '')}`}
																			invalid={nameV}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="4">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}  >Apellido parterno<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="paternal_surname"
																			value={paternal_surname}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(paternal_surnameV ? 'border-danger' : '')}`}
																			invalid={paternal_surnameV}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="4">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Apellido materno<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="maternal_surname"
																			value={maternal_surname}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			invalid={maternal_surnameV}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(maternal_surnameV ? 'border-danger' : '')}`}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="7" className='pb-2' >
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Correo electrónico</b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="email"
																			value={email}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className="form-control form-control-sm input-air-primary b-r-9"
																		/>
																	</Col>
																	<Col sm="5">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Telefono</b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="phone"
																			value={phone}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className="form-control form-control-sm input-air-primary b-r-9"
																		/>
																	</Col>
																	<Col sm="12">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Observaciones</b>
																		<textarea
																			disabled={viewQuoter ? true : false}
																			name="observations"
																			className="form-control input-air-primary form-control-sm "
																			value={observations}
																			onChange={handleInputChange}
																			style={{ fontSize: "11px" }}
																		/>
																	</Col>
																</Row>
															</Col>

															<CustomStudy />
															<Col sm="3">
																<h5>Resúmen del pago</h5>
																<div className={viewDetailQuoter ? "d-none" : "payment-summary"}  >
																	<div className="divider"></div>
																	<div className="icon-and-label" >
																		<i className="icofont icofont-laboratory"></i>
																		<label htmlFor=""> {listQuoterTest.length + " " + "Estudios"} </label>
																	</div>
																</div>
																<Col sm="12" className='shadow-sm canvas-color' style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px' }}>
																	<Table style={{ fontSize: "11px" }}>
																		<tbody>
																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }} >Subtotal</label>
																				</td>
																				<td className="text-center" style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }}>$ {(subTotalW).toFixed(2)}</label>
																				</td>
																			</tr>
																			<tr>
																				<td style={{ padding: "5px" }}>
																					<b style={{ fontSize: "15px" }} className='txt-danger'>Descuento</b>
																				</td>
																				<td className="text-center" style={{ padding: "5px" }}>
																					<b className='txt-danger' style={{ fontSize: "15px" }}  >$ {(totalDiscountW).toFixed(2)}</b>
																				</td>
																			</tr>

																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }} className={'f-w-600 txt-primary'}  >I.V.A</label>
																				</td>
																				<td className="text-center" style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }}>${(totalTaxesW.toFixed(2))}</label>
																				</td>
																			</tr>
																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "18px" }} className='f-w-600'>Total</label>
																				</td>
																				<td className="text-center  " style={{ padding: "5px" }}>
																					<b style={{ fontSize: "16px", color: "#000" }}>$ {(totalW).toFixed(2)}</b>
																				</td>
																			</tr>
																		</tbody>
																	</Table>
																</Col>
																<Row className={viewQuoter ? "d-none" : 'pt-3'}   >
																	<Col sm="12" >
																		<Row className="align-items-center">
																			<Col sm="10">
																				<label className='f-w-500'>Seleccionar descuento</label>
																				<Select
																					isDisabled={listQuoterTest.length === 0 ? true : false}
																					classNamePrefix="select"
																					name="id_preloaded_discount"
																					value={id_preloaded_discount}
																					options={listPreloaded}
																					onChange={(e, actionMeta) => {
																						if (actionMeta.action === "clear") {
																							removePreloadedDiscount();
																						} else {
																							handleSelectValues(e, "id_preloaded_discount");
																						}
																					}}
																					//onChange={(e) => handleSelectValues(e, "id_preloaded_discount")}
																					placeholder="Selecciona un descuento"
																					isClearable={true}
																					menuPlacement="top"
																					menuPortalTarget={document.body}
																					styles={{
																						control: (provided) => ({
																							...provided,
																							fontSize: '11px',
																						}),
																					}}
																					components={{
																						ClearIndicator: CustomClearIndicator,
																					}}
																				/>
																			</Col>
																			<Col sm="2" className="d-flex justify-content-end p-l-0 p-r-0 pt-4">
																				<Button
																					disabled={listQuoterTest.length === 0 ? true : false}
																					label="Aplicar"
																					size="sm"
																					onClick={() => validatePreloadedDiscount()}
																					style={{
																						fontSize: '12px',
																						padding: '5px',
																						backgroundColor: '#28a745',
																						borderColor: '#28a745',
																						color: 'white',
																						width: '100%',
																					}}
																				/>
																			</Col>
																		</Row>
																	</Col>


																</Row>
																<Col sm="12" className='pt-3'>
																	{loading && (
																		<div style={{ position: 'relative', height: '20px' }}>
																			<ProgressBar
																				value={progress}
																				showValue={false}
																				style={{
																					marginBottom: '20px',
																					backgroundColor: '#e0e0e0',
																					height: '10px',
																					visibility: progress === 100 ? 'hidden' : 'visible',
																				}}
																			/>
																			{progress < 100 && (
																				<span style={{
																					position: 'absolute',
																					top: '80%',
																					left: '50%',
																					transform: 'translateX(-50%)',
																					color: '#28a745',
																					fontSize: '14px',
																				}}>
																					Generando descuento...
																				</span>
																			)}
																		</div>
																	)}
																</Col>

																<Row className='pt-2' >
																	<Col sm="12" className={viewQuoter ? "d-none" : ""} >
																		<CustomButton />
																	</Col>
																</Row>
															</Col>
														</Row>
													</Col>

												</div>
											</TabPanel>
											{
												// * COMPANY
											}
											<TabPanel header={<><i className="pi pi-building" style={{ marginRight: '8px' }}></i>Empresa</>}>
												<div className="full-width-content">
													<Col sm="12">
														<Row>
															<Col sm="4">
																<h5>Cliente</h5>
																{
																	chekTypeClient === 3 && <Col sm="12" className='p-l-0 p-r-0'  >
																		<div className='form-group'>
																			<label className='f-w-600' >Selecciona el convenio</label>
																			<Select
																				isDisabled={!viewQuoter ? "" : true}
																				classNamePrefix="select"
																				name="id_agreement"
																				value={id_agreement}
																				placeholder="Selecciona una empresa"
																				options={listAgreement}
																				onChange={(e) => handleSelectValues(e, "id_agreement")}
																				menuPortalTarget={document.body}
																			/>
																		</div>
																	</Col>
																}
																<hr />
																<Row className='pt-2' >
																	<Col sm="4" className='pb-2' >
																		<b className="d-block mb-2" style={{ fontSize: "14px" }} >Nombre<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			disabled={viewQuoter ? true : false}
																			type="text"
																			name="name"
																			value={name}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(nameV ? 'border-danger' : '')}`}
																			invalid={nameV}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="4">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}  >Apellido parterno<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="paternal_surname"
																			value={paternal_surname}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(paternal_surnameV ? 'border-danger' : '')}`}
																			invalid={paternal_surnameV}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="4">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Apellido materno<span className='f-16' style={{ color: "#0079C7" }}>*</span></b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="maternal_surname"
																			value={maternal_surname}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			invalid={maternal_surnameV}
																			className={`form-control form-control-sm input-air-primary b-r-9 ${(maternal_surnameV ? 'border-danger' : '')}`}
																		/>
																		<FormFeedback>Debes llenar este campo</FormFeedback>
																	</Col>
																	<Col sm="7" className='pb-2' >
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Correo electrónico</b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="email"
																			value={email}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className="form-control form-control-sm input-air-primary b-r-9"
																		/>
																	</Col>
																	<Col sm="5">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Telefono</b>
																		<Input
																			type="text"
																			disabled={viewQuoter ? true : false}
																			name="phone"
																			value={phone}
																			required={true}
																			autoComplete="nope"
																			onChange={handleInputChange}
																			className="form-control form-control-sm input-air-primary b-r-9"
																		/>
																	</Col>
																	<Col sm="12">
																		<b className="d-block mb-2" style={{ fontSize: "14px" }}>Observaciones</b>
																		<textarea
																			disabled={viewQuoter ? true : false}
																			name="observations"
																			className="form-control input-air-primary form-control-sm "
																			value={observations}
																			onChange={handleInputChange}
																			style={{ fontSize: "11px" }}
																		/>
																	</Col>
																</Row>
															</Col>											<CustomStudy />

															<Col sm="3">
																<h5>Resúmen del pago</h5>
																<div className={viewDetailQuoter ? "d-none" : "payment-summary"}  >
																	<div className="divider"></div>
																	<div className="icon-and-label" >
																		<i className="icofont icofont-laboratory"></i>
																		<label htmlFor=""> {listQuoterTest.length + " " + "Estudios"} </label>
																	</div>
																</div>
																<Col sm="12" className='shadow-sm canvas-color' style={{ backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '12px' }}>
																	<Table style={{ fontSize: "11px" }}>
																		<tbody>
																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }} >Subtotal</label>
																				</td>
																				<td className="text-center" style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }}>$ {(subTotalW).toFixed(2)}</label>
																				</td>
																			</tr>


																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }} className={'f-w-600 txt-primary'}  >I.V.A</label>
																				</td>
																				<td className="text-center" style={{ padding: "5px" }}>
																					<label style={{ fontSize: "15px" }}>${(totalTaxesW.toFixed(2))}</label>
																				</td>
																			</tr>
																			<tr>
																				<td style={{ padding: "5px" }}>
																					<label style={{ fontSize: "18px" }} className='f-w-600'>Total</label>
																				</td>
																				<td className="text-center  " style={{ padding: "5px" }}>
																					<b style={{ fontSize: "16px", color: "#000" }}>$ {(totalW).toFixed(2)}</b>
																				</td>
																			</tr>
																		</tbody>
																	</Table>
																</Col>
																<Col sm="12" className='pt-3'>
																	{loading && (
																		<div style={{ position: 'relative', height: '20px' }}>
																			<ProgressBar
																				value={progress}
																				showValue={false}
																				style={{
																					marginBottom: '20px',
																					backgroundColor: '#e0e0e0',
																					height: '10px',
																					visibility: progress === 100 ? 'hidden' : 'visible',
																				}}
																			/>
																			{progress < 100 && (
																				<span style={{
																					position: 'absolute',
																					top: '80%',
																					left: '50%',
																					transform: 'translateX(-50%)',
																					color: '#28a745',
																					fontSize: '14px',
																				}}>
																					Generando descuento...
																				</span>
																			)}
																		</div>
																	)}
																</Col>
																<Row className='pt-5' >
																	<Col sm="12" className='p-l-0 p-r-0' >
																		<CustomButton /> <br />
																	</Col>
																</Row>
															</Col>
														</Row>
													</Col>
												</div>
											</TabPanel>
										</TabView>
									</Card>
								}
							</Col>
						</Row>
					</Col>
				</Row>
			</div>

			<ModalViewExamsQuoter
				{
				...{ modalViewExamsP, toggleModalViewExams, viewExamsProfile, handleViewExamsProfile }
				}
			/>
			<ModalRepeatProfile
				{
				...{
					modalRepeatProfile, validationsRepeat, modalTitle, toggleRepeatProfile,
				}
				}
			/>
			<DialogPreviewPdf
				{
				...{
					showPreview, pdfPreviewUrl, setPdfPreviewUrl, setShowPreview
				}
				}
			/>
		</Fragment >
	)
}